/** Renders config param names as highlighted inline code chips. */
export function ParamKeys({ keys }: { keys: string[] }) {
  return (
    <>
      {keys.map((k, i) => (
        <span key={k}>
          {i > 0 && ', '}
          <code className="rounded bg-gray-100 px-1 font-mono text-gray-700">{k}</code>
        </span>
      ))}
    </>
  )
}
